import { render } from "./CreatePress.vue?vue&type=template&id=732789f3"
import script from "./CreatePress.vue?vue&type=script&lang=js"
export * from "./CreatePress.vue?vue&type=script&lang=js"
script.render = render

export default script